// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"249":"7048bc31a27026fa","888":"737104189219f1d6"}[chunkId] + ".css";
};